export type E2EPhase = {
  status: string;
  conclusion?: string;
  reason?: string;
  buildId?: string;
  expoWorkflowId?: string;
  preparationRunId?: number;
};
export type E2EMedia = {
  id: string;
  suiteId: string;
  testId: string;
  attemptId: string;
  kind: 'video' | 'screenshot';
  mediaType: string;
  availability: string;
  redaction: string;
  expiresAt?: string;
};
export type E2ETestAttempt = {
  id: string;
  index: number;
  status: string;
  startedAt: string;
  durationMs: number;
  cleanup: string;
  error?: { code?: string; phase?: string };
  steps: { type: string; title?: string; status: string; durationMs?: number }[];
  mediaIds: string[];
};
export type E2EResult = {
  id: string;
  testId: string;
  titlePath: string[];
  selected: boolean;
  status: string;
  kind: string;
  attempts: E2ETestAttempt[];
};
export type E2ESuite = {
  id: string;
  reportAvailability: string;
  validation: string;
  results: E2EResult[];
};
export type E2EAttempt = {
  runAttempt: number;
  commit: string;
  branch: string;
  environment: string;
  profile: string;
  producedAt: string;
  publishedAt: string;
  apk: E2EPhase;
  tests: E2EPhase;
  reportAvailability: string;
  counters: { passed: number; failed: number; notRun: number };
  suites: E2ESuite[];
  media: E2EMedia[];
};
export type E2ERunSummary = Omit<E2EAttempt, 'suites' | 'media'> & {
  runKey: string;
  runId: number;
  latestAttempt: number;
  githubUrl: string;
  continuationRunId?: number;
};
export default class E2ERun {
  constructor(
    public runKey: string,
    public runId: number,
    public latestAttempt: number,
    public attempts: E2EAttempt[],
    public continuationRunId?: number
  ) {}
  static fromApi(value: E2ERun): E2ERun {
    return new E2ERun(
      value.runKey,
      value.runId,
      value.latestAttempt,
      value.attempts,
      value.continuationRunId
    );
  }
  get githubUrl(): string {
    return `https://github.com/leedgroup/leedpulse-monorepo/actions/runs/${this.runId}`;
  }
  get active(): boolean {
    return this.attempts.some(
      (a) =>
        ['pending', 'in_progress'].includes(a.apk.status) ||
        ['pending', 'in_progress'].includes(a.tests.status)
    );
  }
}
